(function () {
  'use strict';

  angular
    .module('dashboard.project.overview')
    .directive('reportPeriodPicker', reportPeriodPicker);

  reportPeriodPicker.$inject = [];

  function reportPeriodPicker() {
    var directive = {
      bindToController: true,
      controller: 'reportPeriodPickerCtrl',
      template: require('./report.period.picker.html'),
      link: link,
      restrict: 'E',
      scope: {
        type: '=',
        onChange: '=',
      },
    };
    return directive;

    function link(scope, element, attrs, ctrl) {}
  }
})();
